import About from 'components/about/About.jsx'
import clientPromise from "lib/mddb.mjs";
import computeFields from "lib/computeFields";
import React from "react";
import fs from "fs";

export default function AboutPage({blogs}){
  return(
    <About blogs={blogs}/>
  )
}

export async function getStaticProps() {
  const mddb = await clientPromise;

  const blogFiles = await mddb.getFiles({ folder: "blog" });
  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });

  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);
  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);



  return {
    props: {
      meta: {
        title: "About Datopian",
        description: "We're passionate about data. Our mission is to democratize the power of data by giving more people more access to high-quality data and tooling.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
      },
      blogs: blogsList,
      casestudies: caseStudiesList,
    },
  };
};